// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseUrl: 'https://profit4u-001-site1.dtempurl.com/',
  s3Path: 'https://filter-trade-files.s3.amazonaws.com/',
  defaultLang: 'es',
  version: require('../../package.json').version + '-dev',
  api: function (endpoint) {
    return this.baseUrl + endpoint;
  },
};
